/* eslint-disable no-restricted-globals */
/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/jsx-no-target-blank */
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useHistory, useParams } from "react-router-dom";
import "./json-viewer.scss";
import ReactDOM from "react-dom";
import PdfViewer from "./PdfViewer";
import VideoViewer from "./VideoViewer";
import { conceptosJson, searchCitadoEn } from "../../backend/search";
import {
    API_FILTERS,
    API_INDEX,
    PRINCIPAL_DESCRIPTOR_KEY,
    SECOND_DESCRIPTOR_KEY,
    URL_AMBIENTE,
} from "../../backend/settings";
import { generateShareLinks } from "../../utils/share";
import ControlledAccordions from "./Accordion";
import AccordionDetail from "./AccordionDetail";
import menu_icon from "../../../assets/icons/menu_icon.png";
import Whatsapp from "../../../assets/icons/whatsappIcon.png";
import Facebook from "../../../assets/icons/facebookIcon.png";
import LinkedIn from "../../../assets/icons/linkedinIcon.png";
import Share from "../../../assets/icons/share.png";
import Copy from "../../../assets/icons/copy.png";
import Check from "../../../assets/icons/Check.png";
import {
    getSavedBorradores,
    getSelectedFilters,
    getDocumentSearchText,
    getSearchText,
    getTabSelected,
} from "../../store/selectors";
import Logo_delete from "../../../assets/icons/deletel.png";
import {
    saveResults,
    saveBorradores,
    deleteSavedBorrador,
    deleteSavedBorradorKey,
    deleteSavedBorradorKeyPosition,
} from "../../store/actions";
import icon_menu from "../../../assets/icons/menu_mobile.svg";
import icon_sentencia from "../../../assets/icons/icon_sentencia.svg";
import icon_sentencia_oral from "../../../assets/icons/icon_sentencias_orales.svg";
import icon_conceptos from "../../../assets/icons/icon_conceptos.svg";
import icon_temas from "../../../assets/icons/icon_temas.svg";
import icon_problemas from "../../../assets/icons/icon_problemas.svg";
import arrow from "../../../assets/icons/arrow.svg";
import { Modal } from "@material-ui/core";
import { makeStyles, withTheme } from "@material-ui/core/styles";
import { abc, getLetter } from "../../utils";
import { searchCita } from "../../backend/search";
import LibraryBooksIcon from "@material-ui/icons/LibraryBooks";
import BookmarkRemoveIcon from "@material-ui/icons/RemoveCircle";
import classNames from "classnames";
import deepEqual from "deep-equal";
import { updateFilters } from "../../store/actions";
import useSearch from "../../hooks/useSearch";
import AccordionProblems from "./AccordionProblems";
import radioChecked from "../../../assets/icons/radio_checked.svg";
import radioUnChecked from "../../../assets/icons/radio_unchecked.svg";
import Logo_header from "../../../assets/icons/GOV.CO_Logo-whiteGOV.CO_Logo-white.png";
import Logo_marcapais from "../../../assets/icons/marcapais.png";

import { useContentTypes } from "../../utils/content-types-traduction-context";

// Utils
import { has, uniq } from "lodash";

export default function JsonViewer(props) {
    const history = useHistory();
    let borradores = useSelector(getSavedBorradores);

    const selected_filters_selector = useSelector(getSelectedFilters);
    const search_text_selector = useSelector(getSearchText);
    const search_text_document_selector = useSelector(getDocumentSearchText);

    const dispatch = useDispatch();

    const [menuIzq, setMenuIzq] = useState([]);
    const [json, setJson] = useState(null);
    const [etiquetas, setEtiquetas] = useState([]);
    const [titulo, setTitulo] = useState(null);
    const [informacion, setInformacion] = useState(null);
    const [error, setError] = useState(null);

    const { id } = useParams();
    const [_id, setId] = useState(null);

    const username = localStorage["username"];

    const saved_borradores_selector = borradores;

    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const [copied, setCopied] = useState(false);
    
    const shareUrls = generateShareLinks(id);
    const actualUrl = shareUrls.current;
    const completeFacebookUrl = shareUrls.facebook;
    const completeWhatsappUrl = shareUrls.whatsapp;
    const completeLinkedinUrl = shareUrls.linkedin;

    const useStyles = makeStyles((theme) => ({
        modal: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "50px"
        },
        modalBody: {
            backgroundColor: "white",
            padding: "25px",
            borderRadius: "20px",
            border: "1px solid black",
            width: "35vw"
        },
        modalIconsContainer: {
            display: "flex",
            justifyContent: "space-evenly",
            alignItems: "center",
            flexDirection: "row",
            marginBottom: "20px"
        },
        modalUrlContainer: {
            width: "auto"
        },
        urlBox: {
            display: "flex",
            border: "1px solid black",
            alignItems: "center",
            justifyContent: "space-evenly"
        },
        ModalImg: {
            width: "50px",
            cursor: "pointer"
        },
        parrafo: {
            width: "90%",
            padding: "10px",
            border: "none",
            //overflowWrap: "anywhere",
            overflow: "auto",
            fontSize: "15px",
            whiteSpace: "nowrap"
        },
        copy: {
            width: "8%",
            height: "5%",
            cursor: "pointer"
        },
        titulo: {
            margin: "0px 0px 20px 0px"
        }
    }));

    const classes = useStyles();

    const copyUrl = () => {
        var copyText = document.getElementById('redUrl').textContent;
        navigator.clipboard.writeText(copyText);
        setCopied(true)
        setTimeout(() => {
            setCopied(false)
        }, 3000);
    };


    let saved_borrador_r = false;
    if (saved_borradores_selector !== undefined) {
        saved_borradores_selector.forEach((i) => {
            if (i._id === id) {
                saved_borrador_r = true;
            }
        });
    }

    const [borradorState, setBorradorState] = useState(saved_borrador_r);

    const [activeSection, setActiveSection] = useState(0);

    const [expandAll, setExpandAll] = useState(false);

    const getMenu = () => {
        const keys = Object.keys(json);
        keys.map((k) => {
            return k.replace("-", "");
        });
        const fkeys = keys.filter((f) => {
            return (
                f !== "etiquetas" &&
                f !== "informacion" &&
                f !== "titulo" &&
                f !== "borrador" &&
                f !== "funcionalidadCrear" &&
                f !== "tesauro_filtro" &&
                f !== "partes"
            );
        });
        setMenuIzq(fkeys);
    };

    const getCitadoEn = (queryToSearch) => {
        const url = API_FILTERS;
        const body = {
          query: {
            bool: {
              filter: [
                {
                  match: {
                    "fuentes_juridicas.hipervinculo": {
                      query: queryToSearch,
                      operator: "and",
                    },
                  },
                },
              ],
            },
          },
          _source: [
            "informacion.consecutivo",
            "informacion.fecha_sentencia",
            "informacion.numero_radicado",
          ],
          size: 100,
          from: 0,
        };
    
        return fetch(url, {
          method: "POST",
          body: JSON.stringify(body),
          headers: {
            "Content-Type": "application/json",
          },
        })
          .then((response) => response.json())
          .then((data) => {
            return data;
          });
      };

    const getJson = async () => {
        fetch(API_INDEX + id)
            .then((response) => response.json())
            .then(async (data) => {
                if (data.found) {
                    //var countData = data._source.citas.length
                    var citadoEn = []
                    
                   /* for (var i = 0; i < countData; i++){
                        const citas = data._source.citas[i].hipervinculo;
                        citadoEn.push(await getCitadoEn(citas));
                    }
                    */
                   var consecutivoAct = data._source.informacion.consecutivo;
                   var fSentencia = data._source.informacion.fecha_sentencia;
                   var queryTS = "{'numero':'"+consecutivoAct+"', 'fecha': '"+fSentencia+"'}";
                    citadoEn.push(await getCitadoEn(queryTS));
                    if (
                        data._source.informacion.tipo_contenido !==
                        "Conceptos jurídicos"
                    ) {
                        if (data._source.etiquetas[0]) {
                            data._source.etiquetas[0].contenido_archivo =
                                "Transcripción de la sentencia";
                        }
                    } else {
                        if (data._source.etiquetas[0]) {
                            data._source.etiquetas[0].fecha_sentencia = "Fecha";
                        }
                        if (data._source.etiquetas[0]) {
                            data._source.etiquetas[0].contenido_archivo =
                                "Detalle del concepto";
                        }
                    }

                    if (
                        data._source.informacion.tipo_contenido !==
                        "Temas y problemas"
                    ) {
                        data._source.borrador = [
                            "Consideraciones",
                            "Costas",
                            "Resuelve",
                            "problemas_juridicos",
                            "rattio_decidendi",
                            "segunda_instancia",
                            // "aclaracion_o_adicion",
                            "fuentes_juridicas",
                        ];

                        if (
                            data._source.informacion.tipo_contenido ===
                            "Conceptos jurídicos"
                        ) {
                            data._source.borrador = ["contenido_archivo"];
                        }
                    } else {
                        data._source.borrador = [
                            "problemas_juridicos",
                            "problemas_juridicos_temas",
                            "posicion_doctrinal_actual",
                            "posicion_doctrinal_contraria",
                            "reiteracion_doctrina",
                        ];

                        delete data._source.informacion.fecha_sentencia;
                    }

                    if (data._source.fuentes_juridicas) {
                        data._source.fuentes_juridicas.map((fuente) => {
                            delete fuente.actions;
                        });
                    }

                    if (data._source.descriptores) {
                        const descriptores = data._source.descriptores.map(
                            (descriptor) => {
                                const tDescriptor = descriptor;
                                tDescriptor["descriptores_secundarios"] = uniq(
                                    descriptor["descriptores_secundarios"]
                                );
                                return tDescriptor;
                            }
                        );
                    }
                    for (var i = 0; i < citadoEn.length ; i++) {
                        const resultsCitadoEn = citadoEn[i].hits.hits.filter((item) => {
                            if (!('informacion' in item)) return false;
                            if (!('numero_radicado' in item.informacion)) return false;
                            if (_id === item._id) return false;
                            return true;
                        }).map((item) => {
                            const obj = {
                              ...item._source.informacion,
                              hipervinculo:
                                "{'numero':'" +
                                item._source.informacion.numero_radicado +
                                "', 'fecha':  '" +
                                item._source.informacion.fecha_sentencia ?? "" +
                                "'}",
                            };
                            return obj;
                        });
                        data._source["citadoen"] = resultsCitadoEn;
                     }
                    delete data._source.citas; 
                    setJson(data._source);
                    setId(data._id);

                    setEtiquetas(
                        data._source.etiquetas !== undefined
                            ? data._source.etiquetas
                            : []
                    );
                    if ("titulo" in data._source) {
                        setTitulo(data._source.titulo);
                    }
                    if ("informacion" in data._source) {
                        setInformacion(data._source.informacion);
                    }
                } else {
                    setError(
                        "Ya no se encuentra disponible la información asociada a esta sentencia, por favor inicie nuevamente su busqueda."
                    );
                }
            })
            .catch((e) => {
                console.error(e);
            });
    };

    useEffect(() => {
        getJson();
    }, []);

    useEffect(() => {
        if (json !== null) {
            getMenu();
        }
    }, [json]);

    const translateEtiqueta = (etiqueta) => {
        let translate = "";

        etiquetas.forEach((k, v) => {
            if (k[etiqueta]) {
                translate = k[etiqueta];
                return false;
            }
            if (k[etiqueta] === false) {
                translate = false;
            }
        });

        if (etiqueta === "rattio_decidendi") {
            translate = "Caso concreto";
        }

        if (etiqueta === "expediente_tribunal") {
            translate = "Número del expediente en el Tribunal";
        }
        if (etiqueta === "pregunta") {
            translate = "Pregunta";
        }
        if (etiqueta === "pregunta") {
            translate = "Pregunta";
        }
        //if (etiqueta === "citas") {
          // translate = "Fuentes de la Superintendencia";
       // }
        if (etiqueta === "fuentes_juridicas") {
            translate = "Fuentes jurídicas"
        }
        if (etiqueta === "citadoen") {
            translate = "Citado en"
        }
        if (etiqueta === "numero_radicado") {
            translate = "Número de radicado"
        }
        if (etiqueta === "hipervinculo") {
            translate = "Hipervínculo"
        }
        return translate;
    };

    const definitiveComparasion = (obj1, obj2) => {
        // onsole.log(obj1);
        //console.log(obj2);
        const keys1 = Object.keys(obj1);
        const keys2 = Object.keys(obj2);

        if (keys1.length !== keys2.length) return false;

        for (let key of keys1) {
            let val1 = obj1[key];
            let val2 = obj2[key];

            if (val1 !== val2) return false;
        }

        return true;
    };

    const findAvailableAction = (currentKey) => {
        const selectableElements = json.borrador;

        let availableAction = undefined;

        if (selectableElements.includes(currentKey)) {
            if (borradores.length > 0) {
                borradores.forEach((b) => {
                    if (b._id === id) {
                        const found = selectableElements.find(
                            (element) => element === currentKey
                        );

                        if (found) {
                            let isTagFound = !!b[currentKey];
                            if (currentKey === "contenido_archivo") {
                                isTagFound = !!b["conceptos_juridicos"];
                            }

                            if (isTagFound) {
                                availableAction = "delete";
                            } else {
                                availableAction = "add";
                            }
                        } else {
                            availableAction = undefined;
                        }
                    } else {
                        availableAction = "add";
                    }
                });
            } else {
                availableAction = "add";
            }
        } else {
            availableAction = undefined;
        }

        return availableAction;
    };

    const findAvailableActionForPosition = (currentKey, currentElement) => {
        const selectableElements = json.borrador;

        let availableAction = undefined;

        if (selectableElements.includes(currentKey)) {
            if (borradores.length > 0) {
                borradores.forEach((b) => {
                    if (b._id === id) {
                        if (b[currentKey] && json[currentKey]) {
                            /**
                             * Buscar elemento dentro de los borradores
                             */
                            const found = b[currentKey].find((element) =>
                                deepEqual(element, currentElement)
                            );

                            if (found) {
                                availableAction = "delete";
                            } else {
                                availableAction = "add";
                            }
                        }
                    }
                });
            } else {
                availableAction = "add";
            }
        } else {
            availableAction = undefined;
        }

        // if (availableActionFuentes) {
        //   availableAction = 'delete'
        // }

        return availableAction;
    };

    const findAvailableActionForProblem = (currentKey, currentElement) => {
        const selectableElements = json.borrador;

        let availableAction = undefined;

        if (selectableElements.includes(currentKey)) {
            if (borradores.length > 0) {
                borradores.forEach((b) => {
                    if (b._id === id) {
                        if (
                            b[currentKey] &&
                            json["analisis_juridico"][currentKey]
                        ) {
                            /**
                             * Buscar elemento dentro de los borradores
                             */
                            const found = b[currentKey].find((element) =>
                                deepEqual(element, currentElement)
                            );

                            if (found) {
                                availableAction = "delete";
                            } else {
                                availableAction = "add";
                            }
                        }
                    }
                });
            } else {
                availableAction = "add";
            }
        } else {
            availableAction = undefined;
        }

        return availableAction;
    };
    const showDetail = (key, item) => {
        setOpenMenu(false);
    };

    const tipoDeContenido = (content) => {
        const typeOf = typeof content;

        if (Array.isArray(content)) {
            return (
                <div className="subtable">
                    <div>{DetailArray(content)}</div>
                </div>
            );
        }
        if (typeOf === "string" || typeOf === "number") {
            return <div className="simple s1">{content}</div>;
        }
        if (typeOf === "object") {
            return (
                <div className="object">
                    <div>{DetailObject(content)}</div>
                </div>
            );
        }
    };

    const DetailArray = (values, currentKey = null) => {
        const availableAction = findAvailableAction(currentKey);

        if (values.length > 0) {
            let headers = [];
            let valueTwo = [];

            values.forEach((v) => {
                if (typeof v === "object") {
                    headers = Object.keys(v);
                    valueTwo.push(Object.values(v));
                } else {
                    valueTwo.push(v);
                }
            });

            const keysDeleted = [];

            const headerFiltrados = headers.filter((h, k) => {
                if (translateEtiqueta(h) === false) {
                    keysDeleted.push(k);
                }
                return translateEtiqueta(h) !== false;
            });

            valueTwo.map((v, k) => {
                keysDeleted.forEach((kd, i) => {
                    let indice = kd - i;
                    v.splice(indice, 1);
                });
                if (username !== undefined) {
                    if (
                        currentKey === "fuentes_juridicas" ||
                        currentKey === "problemas_juridicos" ||
                        currentKey === "problemas_juridicos_temas"
                    ) {
                        v.push("");
                    }
                }
                return v;
            });

            if (username !== undefined) {
                if (currentKey === "fuentes_juridicas") {
                    headerFiltrados.push("acciones");
                }
                if (currentKey === "problemas_juridicos") {
                    headerFiltrados.push("acciones_problemas_juridicos");
                }
                if (currentKey === "problemas_juridicos_temas") {
                    headerFiltrados.push("acciones_problemas_juridicos");
                }
            }

            let numbersHeader = headerFiltrados.length;

            if (numbersHeader >= 10) {
                numbersHeader = 6;
            }

            const div = (
                <div
                    className="table-container"
                    role="table"
                    aria-label="Destinations"
                >
                    <div className="flex-table header-table" role="rowgroup">
                        {headerFiltrados.length > 0 &&
                            headerFiltrados.map((h, i) => {
                                return (
                                    <div
                                        className={`${
                                            i === 0
                                                ? "flex-row first"
                                                : "flex-row"
                                        }`}
                                        role="columnheader"
                                        style={{
                                            width: `calc(100% / ${numbersHeader})`,
                                        }}
                                        id={h}
                                    >
                                        {h !== "acciones" && (
                                            <p>
                                                {translateEtiqueta(h) !== ""
                                                    ? translateEtiqueta(h)
                                                    : h}
                                            </p>
                                        )}
                                        {h === "acciones" && (
                                            <div className="acciones-fuentes">
                                                {availableAction && (
                                                    <div className="actions-accordion-borrador">
                                                        <button
                                                            title={
                                                                availableAction ===
                                                                "delete"
                                                                    ? "Eliminar fuentes del borrador"
                                                                    : "Agregar fuentes al borrador"
                                                            }
                                                            onClick={() => {
                                                                if (
                                                                    availableAction ===
                                                                    "delete"
                                                                ) {
                                                                    deleteToBorradorPadre(
                                                                        json,
                                                                        "fuentes_juridicas"
                                                                    );
                                                                } else {
                                                                    addToBorrador(
                                                                        json,
                                                                        "fuentes_juridicas"
                                                                    );
                                                                }
                                                            }}
                                                        >
                                                            {availableAction ===
                                                            "delete" ? (
                                                                <BookmarkRemoveIcon
                                                                    className={classNames(
                                                                        "borrador_icon delete"
                                                                    )}
                                                                />
                                                            ) : (
                                                                <LibraryBooksIcon
                                                                    className={classNames(
                                                                        "borrador_icon active"
                                                                    )}
                                                                />
                                                            )}
                                                        </button>
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                );
                            })}
                    </div>
                    {valueTwo.map((item, j) => {
                        return (
                            <div
                                className={`${
                                    Array.isArray(item)
                                        ? "flex-table row"
                                        : "row"
                                }`}
                                role="rowgroup"
                            >
                                {Array.isArray(item) ? (
                                    item.map((i, k) => {
                                        const typeOf = typeof i;
                                        if (Array.isArray(i)) {
                                            return (
                                                <div
                                                    style={{
                                                        width: `calc(100% / ${numbersHeader})`,
                                                    }}
                                                    className={`op1 flex-row ${
                                                        k === 0 ? "first" : ""
                                                    }`}
                                                    role="cell"
                                                >
                                                    <div>
                                                        {DetailArray(
                                                            item[k],
                                                            headerFiltrados[k]
                                                        )}
                                                    </div>
                                                </div>
                                            );
                                        }
                                        if (
                                            typeOf === "string" ||
                                            typeOf === "number"
                                        ) {
                                            return (
                                                <div
                                                    style={{
                                                        width: `calc(100% / ${numbersHeader})`,
                                                    }}
                                                    className={`op2 ${
                                                        headerFiltrados[k]
                                                    } flex-row ${
                                                        k === 0 ? "first" : ""
                                                    }`}
                                                    role="cell"
                                                    title={i}
                                                >
                                                    {writeValue(
                                                        i,
                                                        currentKey,
                                                        headerFiltrados[k],
                                                        j
                                                    )}
                                                </div>
                                            );
                                        }
                                        if (typeOf === "object") {
                                            return (
                                                <div
                                                    style={{
                                                        width: `calc(100% / ${numbersHeader})`,
                                                    }}
                                                    className={`op3 flex-row ${
                                                        k === 0 ? "first" : ""
                                                    }`}
                                                    role="cell"
                                                >
                                                    {DetailObject(item[k])}
                                                </div>
                                            );
                                        }
                                    })
                                ) : currentKey !==
                                  "descriptores_secundarios" ? (
                                    <div className="simple s2">{item}</div>
                                ) : (
                                    <span
                                        className="hipervinculo descriptores two"
                                        onClick={() => {
                                            restartSearch(
                                                item,
                                                SECOND_DESCRIPTOR_KEY
                                            );
                                        }}
                                    >
                                        {item}
                                    </span>
                                )}
                            </div>
                        );
                    })}
                </div>
            );

            return div;
        } else {
            return (
                <p className="without-info">
                    No hay información para visualizar
                </p>
            );
        }
    };

    const DetailObject = (object) => {
        if (object !== null) {
            const listItems = [];

            Object.entries(object).forEach(([key, value]) => {
                if (value !== null) {
                    const availableAction = findAvailableAction(key);
                    listItems.push(
                        <div key={`detail-${key}`} className="detail v4">
                            <div className="detail-title">
                                {translateEtiqueta(key) !== ""
                                    ? translateEtiqueta(key)
                                    : key}
                                {username !== undefined && availableAction && (
                                    <div className="actions-accordion-borrador">
                                        <button
                                            id={`btn-borrador-${key}`}
                                            title={
                                                availableAction === "delete"
                                                    ? "Eliminar ítem del borrador"
                                                    : "Agregar ítem al borrador"
                                            }
                                            onClick={() => {
                                                if (
                                                    availableAction === "delete"
                                                ) {
                                                    // deleteToBorrador(key)
                                                } else {
                                                    addToBorrador(json, key);
                                                }
                                            }}
                                        >
                                            {availableAction === "delete" ? (
                                                <BookmarkRemoveIcon
                                                    id={`span-${key}`}
                                                    className={classNames(
                                                        "borrador_icon delete"
                                                    )}
                                                />
                                            ) : (
                                                <LibraryBooksIcon
                                                    id={`span-${key}`}
                                                    className={classNames(
                                                        "borrador_icon active"
                                                    )}
                                                />
                                            )}
                                        </button>
                                    </div>
                                    // !borradorState && (
                                    // <span
                                    //   onClick={() => {
                                    //     addToBorrador(json, key)
                                    //   }}
                                    // >
                                    //   <div title='Borrador Viewer'>
                                    //     <LibraryBooksIcon className='borrador_icon' />
                                    //   </div>
                                    // </span>
                                    // )
                                )}
                            </div>
                            {tipoDeContenido(value)}
                        </div>
                    );
                }
            });

            return <div>{listItems}</div>;
        }
    };

    const getCita = async (idContainer, value) => {
        const body = {
            fecha: value.fecha,
            numero: value.numero,
        };
        const resultCitadoEn = await searchCitadoEn(body);

        let urlCitadoEn = "";

        try{
            if (resultCitadoEn.hits.hits.length > 0) {
                const target = document.getElementById(idContainer + value.fecha);

                urlCitadoEn =
                    URL_AMBIENTE +
                    "#/jsonviewer/" +
                    resultCitadoEn.hits.hits[0]["_id"];

                if (target !== null) {
                    target.innerHTML = urlCitadoEn;
                    target.href = urlCitadoEn;
                }
            }
        }catch (error) {
            console.error(error);
            // expected output: ReferenceError: nonExistentFunction is not defined
            // Note - error messages will vary depending on browser
          }
    };

    const buildHipervinculo = (value) => {
        
        let valueClear = value.replaceAll(/\n/g, "");
        let fuente = valueClear.replaceAll(/['"]/g, '"');
        fuente = fuente.replaceAll(" ", "");
        if (fuente === "") return null;

        try {
            fuente = JSON.parse(fuente);
        } catch (error) {
            fuente = fuente.replaceAll('"}', '""}');
            fuente = JSON.parse(fuente);
            console.error(error);
        }

        const idContainer = fuente.numero.trim();

        getCita(idContainer, fuente);

        return (
            <a
                id={idContainer + fuente.fecha}
                className="hipervinculo pre-line"
                target="_blank"
            ></a>
        );
    };

    const writeValue = (
        value,
        currentKey = null,
        header = null,
        position = null
    ) => {
        const videFormat = [
            ".mp4",
            ".mkv",
            ".flv",
            ".wmv",
            ".avi",
            ".mp3",
            ".wma",
            ".wav",
            ".m4a",
            ".asf",
        ];
        const docFormat = [".doc", ".docx", ".txt", ".pdf", ".rtf"];

        if (typeof value === "string") {
            if (value.startsWith("https:") || value.startsWith("http:")) {
                return (
                    <a
                        className="hipervinculo 1 pre-line"
                        href={value}
                        target="_blank"
                    >
                        {value}
                    </a>
                );
            }

            if (docFormat.some((format) => value.endsWith(format))) {
                return <PdfViewer url={value}></PdfViewer>;
            }

            if (videFormat.some((format) => value.endsWith(format))) {
                return <VideoViewer url={value}></VideoViewer>;
            }
            if (currentKey === "citas" && header === "hipervinculo") {
                const cHipervinculo = buildHipervinculo(value);

                return cHipervinculo;
            }
            if (currentKey === "citadoen" && header === "hipervinculo") {
                debugger;
                const cHipervinculo = buildHipervinculo(value);
        
                return cHipervinculo;
              }
            if (
                currentKey === "fuentes_juridicas" &&
                header === "hipervinculo"
            ) {
                const rHipervinculo = buildHipervinculo(value);

                return rHipervinculo;
            }

            if (currentKey === "fuentes_juridicas" && header === "acciones") {
                const availableActionForPosition =
                    findAvailableActionForPosition(
                        currentKey,
                        json["fuentes_juridicas"][position]
                    );

                return (
                    <div className="acciones_fuente_unit">
                        <button
                            id={`btn-fuente_juridica-${position}`}
                            title={
                                availableActionForPosition === "delete"
                                    ? "Eliminar fuente del borrador"
                                    : "Agregar fuente al borrador"
                            }
                            onClick={() => {
                                if (availableActionForPosition === "delete") {
                                    deleteToBorradorInArray(
                                        position,
                                        "fuentes_juridicas",
                                        json["fuentes_juridicas"][position]
                                    );
                                } else {
                                    addToBorrador(
                                        json,
                                        "fuentes_juridicas",
                                        position,
                                        `span-fuente_juridica-${position}`
                                    );
                                }
                            }}
                        >
                            {availableActionForPosition === "delete" ? (
                                <BookmarkRemoveIcon
                                    className={classNames(
                                        "borrador_icon delete"
                                    )}
                                />
                            ) : (
                                <LibraryBooksIcon
                                    className={classNames(
                                        "borrador_icon active"
                                    )}
                                />
                            )}
                        </button>
                    </div>
                );
            }

            if (
                currentKey === "problemas_juridicos" &&
                header === "acciones_problemas_juridicos"
            ) {
                const availableActionForPosition =
                    findAvailableActionForProblem(
                        currentKey,
                        json["analisis_juridico"]["problemas_juridicos"][
                            position
                        ]
                    );
                return (
                    <div className="acciones_problema_unit">
                        <button
                            id={`btn-problema_juridico-${position}`}
                            title={
                                availableActionForPosition === "delete"
                                    ? "Eliminar problema del borrador"
                                    : "Agregar problema al borrador"
                            }
                            onClick={() => {
                                if (availableActionForPosition === "delete") {
                                    // deleteToBorradorInArray(position, 'problemas_juridicos', json)
                                    deleteToBorradorInArray(
                                        position,
                                        "problemas_juridicos",
                                        json["analisis_juridico"][
                                            "problemas_juridicos"
                                        ][position]
                                    );
                                } else {
                                    addToBorrador(
                                        json,
                                        "problemas_juridicos",
                                        position,
                                        `span-problema_juridico-${position}`
                                    );
                                }
                            }}
                        >
                            {availableActionForPosition === "delete" ? (
                                <BookmarkRemoveIcon
                                    className={classNames(
                                        "borrador_icon delete"
                                    )}
                                />
                            ) : (
                                <LibraryBooksIcon
                                    className={classNames(
                                        "borrador_icon active"
                                    )}
                                />
                            )}
                        </button>
                    </div>
                );

                // return <div className='acciones_accordion'>
                //   <button
                //     id={`span-problema_juridico-${position}`}
                //     className='borrador_btn'
                //     onClick={() => {
                //       addToBorrador(json, 'problemas_juridicos', position, `span-problema_juridico-${position}`)
                //     }}
                //   >
                //     <div title='Agregar problema a borrador' >
                //       <LibraryBooksIcon className='borrador_icon' />
                //     </div>
                //   </button>
                //   <button
                //     id={`btn-remove-problema_juridico-${position}`}
                //     className='borrador_remove_btn'
                //     onClick={() => {
                //       deleteToBorradorInArray(position, 'problemas_juridicos', json)
                //       //deleteToBorradorInArray(json, 'problemas_juridicos', position, `span-problema_juridico-${position}`)
                //     }}
                //   >
                //     <div title='Eliminar problema de borrador' >
                //       <BookmarkRemoveIcon className='borrador_remove_icon' />
                //     </div>
                //   </button>
                // </div>
            }

            if (currentKey === "descriptores") {
                return (
                    <span
                        className="hipervinculo descriptores three"
                        onClick={() => {
                            restartSearch(value, PRINCIPAL_DESCRIPTOR_KEY);
                        }}
                    >
                        {value}
                    </span>
                );
            }

            return <p className="pre-line">{value}</p>;
        }

        if (typeof value === "object") {
            return (
                <div className="object">
                    <div>{DetailObject(value)}</div>
                </div>
            );
        }

        return value;
    };

    const DetailArchivos = (data) => {
        const listItems = [];
        data.forEach((d, k) => {
            const div = <ControlledAccordions data={d} writeValue />;

            listItems.push(div);
        });

        if (data.length === 0) {
            return (
                <div className="detail">
                    <p className="without-info">No hay archivos asociados</p>
                </div>
            );
        }

        return listItems;
    };

    const DrawProblemsTheme = (values, currentKey = null) => {
        const problemas = [];

        values.forEach((value, index) => {
            const p = (
                <AccordionProblems
                    expandir={expandAll}
                    title={`Problema ${index + 1}`}
                    etiqueta={currentKey}
                    availableAction={findAvailableAction(currentKey)}
                    borradores={borradores}
                    itemId={_id}
                    item={json}
                    currentKey
                    numProblem={index}
                    content={
                        Array.isArray(value) === false ? (
                            <div className="detail-content">
                                {writeValue(value)}
                            </div>
                        ) : (
                            <div
                                id={`g9-${index}`}
                                className={`detail-content-array v9 ${
                                    username !== undefined ? "v9-logueado" : ""
                                }`}
                            >
                                {DetailArray(value, index)}
                            </div>
                        )
                    }
                    fnAddToBorrador={addProblemaToBorrador}
                    fnDeleteToBorrador={deleteToBorradorPadre}
                />
            );
            problemas.push(p);
        });

        if (problemas.length === 0) {
            return <p>No hay problemas asocidados</p>;
        }
        return problemas;
    };

    const Details = (detail) => {
        const numbers = detail.numbers;
        const title = detail.title;

        const listItems = [];
        let i = 0;
        Array.isArray(numbers) === false &&
            typeof numbers !== "string" &&
            Object.entries(numbers).forEach(([key, value]) => {
                // console.log(key + ' ' + value);
                if (value !== null) {
                    listItems.push(
                        <AccordionDetail
                            expandir={i === 0 ? true : false}
                            title={
                                translateEtiqueta(key) !== ""
                                    ? translateEtiqueta(key)
                                    : key
                            }
                            etiqueta={key}
                            availableAction={findAvailableAction(key)}
                            borradores={borradores}
                            itemId={_id}
                            item={json}
                            itemKey={key}
                            dispatch={dispatch}
                            content={
                                Array.isArray(value) === false ? (
                                    <div className="detail-content">
                                        {writeValue(value)}
                                    </div>
                                ) : (
                                    <div
                                        id={`g6-${key}`}
                                        className={`detail-content-array v6 ${
                                            username !== undefined
                                                ? "v6-logueado"
                                                : ""
                                        }`}
                                    >
                                        {DetailArray(value, key)}
                                    </div>
                                )
                            }
                            fnAddToBorrador={addToBorrador}
                            fnDeleteToBorrador={deleteToBorradorPadre}
                        />
                    );
                }

                i++;
            });

        Array.isArray(numbers) === true &&
            Array.isArray(numbers) === true &&
            title !== "problemas_juridicos_temas" &&
            title !== "archivos" &&
            listItems.push(
                <div id={`g2-${title}`} className="detail v2">
                    {DetailArray(numbers, title)}
                </div>
            );

        Array.isArray(numbers) === true &&
            (title === "archivos" || title === "archivos_apoyo") &&
            listItems.push(
                <div className="detail v5">{DetailArchivos(numbers)}</div>
            );

        Array.isArray(numbers) === true &&
            title === "problemas_juridicos_temas" &&
            listItems.push(
                <div id={`g7-${title}`} className="v7">
                    <div className="expandAll">
                        <img
                            src={expandAll ? radioChecked : radioUnChecked}
                            alt="Expandir"
                        />
                        <label
                            htmlFor="expandAll"
                            onClick={() => {
                                setExpandAll(!expandAll);
                            }}
                        >
                            Expandir todo
                        </label>
                    </div>
                    {DrawProblemsTheme(numbers, title)}
                </div>
            );

        if (typeof numbers === "string" || typeof numbers === "number") {
            listItems.push(
                <div className="detail v3">
                    <p className="detail-title">
                        {translateEtiqueta(title) !== ""
                            ? translateEtiqueta(title)
                            : title}
                    </p>
                    <div className="detail-content">{numbers}</div>
                </div>
            );
        }

        if (listItems.length === 0) {
            return (
                <div className="detail">
                    <p className="without-info">
                        No se encontro <span>{translateEtiqueta(title)}</span>{" "}
                        asociado a la sentencia
                    </p>
                </div>
            );
        }
        return <div className="list-items">{listItems}</div>;
    };

    const WriteDetail = ({ item }) => {
        const detail = json[item];

        if (detail !== undefined) {
            return <Details numbers={detail} title={item} />;
        } else {
            return null;
        }
    };

    const writeInformacionGeneral = (informacion) => {
        const listItems = [];

        const orderInfoSentencias = [
            "numero_radicado",
            "fecha_sentencia",
            "consecutivo",
            "numero_proceso",
            "tramite",
            "tema",
            "ano_expediente",
            "normatividad",
            "fecha_ultima_modificacion",
        ];
        Object.entries(informacion).forEach(([key, value]) => {
            if (value !== null) {
                if (key !== "tipo_contenido" && key !== "fecha_larga") {
                    listItems.push(
                        <div
                            className="informacion-general_column"
                            key={`i-${key}`}
                        >
                            <p>
                                <span className="informacion-general_column--title">
                                    {translateEtiqueta(key) !== ""
                                        ? translateEtiqueta(key)
                                        : key}
                                    :{" "}
                                </span>
                                <span>{value}</span>
                            </p>
                        </div>
                    );
                }
            }
        });

        if (informacion["tipo_contenido"].includes("Sentencia")) {
            let normatividad = listItems.filter(
                (f) => f.key === "i-normatividad"
            );
            let aexpendiente = listItems.filter(
                (f) => f.key === "i-ano_expediente"
            );

            if (normatividad.length > 0 && aexpendiente.length > 0) {
                const positionOne = listItems.indexOf(aexpendiente[0]);
                const positionTwo = listItems.indexOf(normatividad[0]);
                normatividad = normatividad[0];
                aexpendiente = aexpendiente[0];

                listItems[positionOne] = aexpendiente;
                listItems[positionTwo] = normatividad;
            }
        }

        return listItems;
    };

    const MenuIzquierdo = ({ activeItem, items }) => {
        return items.map((itemMenu, index) => {
            return (
                itemMenu !== "etiquetas" &&
                itemMenu !== "titulo" &&
                itemMenu !== "informacion" &&
                itemMenu !== "partes" &&
                translateEtiqueta(itemMenu) !== false && (
                    <div
                        key={`item-title-${index}`}
                        id={`item-title-${index}`}
                        className="item-title"
                        active={activeItem === index && "true"}
                        onClick={() => {
                            setActiveSection(index);
                            showDetail(index, itemMenu);
                        }}
                    >
                        <span className="literal">{getLetter(index)}.</span>
                        <p className="text-title">
                            {translateEtiqueta(itemMenu) !== ""
                                ? translateEtiqueta(itemMenu)
                                : itemMenu}
                        </p>
                    </div>
                )
            );
        });
    };

    const [openMenu, setOpenMenu] = useState(false);
    const showMenuMobile = () => {
        const menu = document.getElementById("json-viewer--menu");
        const content = document.getElementById("json-viewer--content");

        setOpenMenu(!openMenu);
    };

    const [showMenu, setShowMenu] = useState(true);
    const showMenuDesktop = () => {
        setShowMenu(!showMenu);
    };

    const addToBorrador = (item, title, position = null, idSpan) => {
        event.preventDefault();

        // borradores = JSON.parse(localStorage['redux']).savedBorradores;
        const found = borradores.filter((element) => {
            return element.id_relatoria === item.id_relatoria;
        });

        let borradorObj = null;

        if (found.length === 0) {
            borradorObj = {
                _id: _id,
                id_relatoria: item.id_relatoria,
                num_proceso: item.informacion.numero_radicado
                    ? item.informacion.numero_radicado
                    : item.id_relatoria,
            };
        } else {
            borradorObj = found[0];
        }

        if (selected_filters_selector.pretensionesDemanda !== "") {
            borradorObj["pretensionesDemanda"] =
                selected_filters_selector.pretensionesDemanda;
        }

        if (selected_filters_selector.hechosRelevantesDemanda !== "") {
            borradorObj["hechosRelevantesDemanda"] =
                selected_filters_selector.hechosRelevantesDemanda;
        }

        if (
            selected_filters_selector.hechosRelevantesContestacionDemanda !== ""
        ) {
            borradorObj["hechosRelevantesContestacionDemanda"] =
                selected_filters_selector.hechosRelevantesContestacionDemanda;
        }

        if (title === "Consideraciones") {
            if (item.metadatos.Consideraciones !== null) {
                borradorObj["Consideraciones"] = item.metadatos.Consideraciones;
            }
        }

        if (title === "Costas") {
            if (item.metadatos.Costas !== null) {
                borradorObj["Costas"] = item.metadatos.Costas;
            }
        }

        if (title === "Resuelve") {
            if (item.metadatos.Resuelve !== null) {
                borradorObj["Resuelve"] = item.metadatos.Resuelve;
            }
        }

        // if (title === "Aclaración o adición") {
        //     if (item.analisis_juridico.aclaracion_o_adicion !== null) {
        //         borradorObj["aclaracion_o_adicion"] =
        //             item.analisis_juridico.aclaracion_o_adicion;
        //     }
        // }

        if (title === "problemas_juridicos") {
            if (item.analisis_juridico !== null) {
                if (borradorObj["problemas_juridicos"] === undefined) {
                    borradorObj["problemas_juridicos"] = [];
                }

                if (position !== null) {
                    borradorObj["problemas_juridicos"].push(
                        item.analisis_juridico.problemas_juridicos[position]
                    );
                } else {
                    borradorObj["problemas_juridicos"] =
                        item.analisis_juridico.problemas_juridicos;

                    // const iconClicked = document.getElementById(`span-${title}`)
                    // if(iconClicked) {
                    //   iconClicked.classList.add("active");
                    // }

                    // const containerProblemas = document.getElementById(`g2-${title}`)
                    // const spansBorrador = containerProblemas.getElementsByClassName('borrador_btn')
                    // for (let element of spansBorrador) {
                    //   element.classList.add("active");
                    // }
                }

                // const spanClicked = document.getElementById(idSpan)
                // if(spanClicked) {
                //   spanClicked.classList.add("active");
                // }

                // if (item.analisis_juridico.problemas_juridicos.length <= borradorObj.problemas_juridicos.length) {
                //   const parentIcon = document.getElementById(`btn-borrador-Problemas juridicos`)
                //   if(parentIcon) {
                //     parentIcon.classList.add("active");
                //   }
                // }
            }
        }

        if (title === "Problemas juridicos") {
            if (item.analisis_juridico !== null) {
                borradorObj["problemas_juridicos"] =
                    item.analisis_juridico.problemas_juridicos;
            }
        }

        if (title === "Rattio decidendi") {
            if (item.analisis_juridico.rattio_decidendi !== null) {
                borradorObj["rattio_decidendi"] =
                    item.analisis_juridico.rattio_decidendi;
            }
        }

        if (title === "Segunda instancia") {
            if (item.analisis_juridico.segunda_instancia !== null) {
                borradorObj["segunda_instancia"] =
                    item.analisis_juridico.segunda_instancia;
            }
        }

        if (title === "fuentes_juridicas") {
            if (item.fuentes_juridicas !== null) {
                if (borradorObj["fuentes_juridicas"] === undefined) {
                    borradorObj["fuentes_juridicas"] = [];
                }

                if (position !== null) {
                    borradorObj["fuentes_juridicas"].push(
                        item.fuentes_juridicas[position]
                    );
                } else {
                    borradorObj["fuentes_juridicas"] = item.fuentes_juridicas;
                }
            }
        }

        if (title === "posicion_doctrinal_actual") {
            if (item.posicion_doctrinal_actual !== null) {
                if (borradorObj["posicion_doctrinal_actual"] === undefined) {
                    borradorObj["posicion_doctrinal_actual"] = [];
                }

                if (position !== null) {
                    borradorObj["posicion_doctrinal_actual"].push(
                        item.posicion_doctrinal_actual[position]
                    );
                } else {
                    borradorObj["posicion_doctrinal_actual"] =
                        item.posicion_doctrinal_actual;
                }
            }
        }

        if (title === "Detalle del concepto") {
            if (item.documento_principal.contenido_archivo !== null) {
                borradorObj["conceptos_juridicos"] =
                    item.documento_principal.contenido_archivo;
            }
        }

        dispatch(deleteSavedBorrador(borradorObj));

        dispatch(saveBorradores(borradorObj));
    };

    const deleteToBorradorPadre = (itemToDeleted, itemKeyToDeleted) => {
        if (itemKeyToDeleted === "contenido_archivo") {
            itemKeyToDeleted = "conceptos_juridicos";
        }
        dispatch(deleteSavedBorradorKey(_id, itemKeyToDeleted));
    };

    const deleteToBorradorInArray = (position, key, elementToDelete) => {
        dispatch(deleteSavedBorradorKeyPosition(_id, key, elementToDelete));
    };

    const { startSearch, startSearchByDocument } = useSearch();

    const [filters, setFilters] = useState(selected_filters_selector);

    const restartSearch = (value, filterKey) => {
        let newFilters = { ...filters };

        Object.entries(filters).forEach(([filter, value]) => {
            newFilters[filter] = "";
        });

        if (filterKey === PRINCIPAL_DESCRIPTOR_KEY) {
            newFilters = {
                ...newFilters,
                principalDescriptors: value,
            };
        } else {
            newFilters = {
                ...newFilters,
                secondDescriptors: value,
            };
        }

        setFilters(newFilters);
        dispatch(updateFilters(newFilters));

        if (search_text_document_selector !== "") {
            startSearchByDocument(search_text_document_selector, 1, newFilters);
        } else {
            startSearch(search_text_selector, 1, newFilters);
        }

        history.push("/results");
    };

    const addProblemaToBorrador = (item, title, position) => {
        event.preventDefault();

        const found = borradores.filter((element) => {
            return element.id_relatoria === item.id_relatoria;
        });

        let borradorObj = null;

        if (found.length === 0) {
            borradorObj = {
                _id: _id,
                id_relatoria: item.id_relatoria,
                num_proceso: item.informacion.numero_radicado
                    ? item.informacion.numero_radicado
                    : item.id_relatoria,
            };
        } else {
            borradorObj = found[0];
        }

        const problemToAdd = item["problemas_juridicos_temas"][position];

        if (borradorObj["problemas_juridicos_temas"] !== undefined) {
            borradorObj["problemas_juridicos_temas"].push(problemToAdd);
        } else {
            borradorObj["problemas_juridicos_temas"] = [];
            borradorObj["problemas_juridicos_temas"].push(problemToAdd);
        }

        dispatch(deleteSavedBorrador(borradorObj));

        dispatch(saveBorradores(borradorObj));
    };

    const tabSelectedRedux = useSelector((state) => state.tabSelected);

    // Obtener contentTypes del contexto
    const contentTypes = useContentTypes();

    // Verificar que contentTypes esté cargado, sea un array y tenga al menos un elemento
    if (!contentTypes || !Array.isArray(contentTypes) || contentTypes.length === 0) {
        return <div>Cargando...</div>; // Mostrar loading si los tipos no están cargados
    }

    // Acceder al primer elemento del array contentTypes que contiene el objeto de traducción
    const contentTypesObject = contentTypes[0];

    // Transformar el objeto en un formato label/value
    const contentTypeMap = Object.entries(contentTypesObject).reduce((acc, [key, value]) => {
        acc[key] = { label: key, value: value };
        return acc;
    }, {});

    // Función para convertir a singular eliminando 's' de palabras en plural
    const convertirASingular = (palabra) => {
        // Limpiar la palabra de espacios en blanco
        const palabraLimpiada = palabra.replace(/\s+/g, ' ').trim(); // Reemplazar múltiples espacios por uno solo y eliminar espacios en blanco al inicio y final

        // Usar expresión regular para quitar 's' al final de cada palabra que la tenga
        return palabraLimpiada.replace(/\b(\w+)s\b/g, '$1'); // Quitar 's' de las palabras que terminan en 's'
    };

    // Obtener el tipo de contenido del resultado
    const tipoContenido = informacion?.tipo_contenido;

    // Obtener la traducción del tipo de contenido
    let tipoTraducido = contentTypeMap[tipoContenido]?.value || tipoContenido;

    // Convertir a singular
    tipoTraducido = tipoTraducido ? convertirASingular(tipoTraducido) : tipoTraducido;

    return (
        <>
            <div className="section_return">
                <Link
                    to="/results?restart=true"
                    className="back-link"
                    onClick={() => {
                        // let filters = JSON.parse(
                        //     JSON.stringify(selected_filters_selector)
                        // );
                        // let cleanFilter = filters;
                        // cleanFilter["content"] = "";
                        // dispatch(updateFilters(cleanFilter));
                    }}
                >
                    {"<"} VOLVER{" "}
                </Link>
            </div>

            {error !== null && (
                <div className="error-container">
                    <div className="error-msg">{error}</div>
                </div>
            )}

            <div className="informacion-general">
                {titulo !== null && (
                    <div className="informacion-general_title">
                        <h2>{titulo}</h2>
                        <button className="boton_prueba"
                        onClick={handleOpen}
                        >
                            <img
                                alt="share"
                                src={Share}
                                width="15px"
                            ></img>
                            <div>Compartir</div>
                        </button>
                        <Modal
                                        open={open}
                                        onClose={handleClose}
                                        className={classes.modal}
                                        aria-labelledby="modal-modal-title"
                                        aria-describedby="modal-modal-description"
                                        >
                                        <div className={classes.modalBody}>
                                            <section>
                                                <h2 className={classes.titulo}>Compartir</h2>
                                            </section>
                                            <section className={classes.modalIconsContainer}>
                                                <a href={completeFacebookUrl} target="_blank">
                                                    <img
                                                        alt="Facebook"
                                                        src={Facebook}
                                                        className={classes.ModalImg}
                                                    ></img>
                                                </a>
                                                <a href={completeWhatsappUrl} target="_blank">
                                                    <img
                                                        alt="Whatsapp"
                                                        src={Whatsapp}
                                                        className={classes.ModalImg}
                                                    ></img>
                                                </a>
                                                <a href={completeLinkedinUrl} target="_blank">
                                                    <img
                                                        alt="LinkedIn"
                                                        src={LinkedIn}
                                                        className={classes.ModalImg}
                                                    ></img>
                                                </a>
                                            </section>
                                            <section className={classes.modalUrlContainer}>
                                                <div className={classes.urlBox}>
                                                    <p className={classes.parrafo} id="redUrl">
                                                        {actualUrl}
                                                    </p>
                                                    {copied ? (
                                                        <>
                                                            <img
                                                                alt="Check"
                                                                src={Check}
                                                                className={classes.copy}
                                                                onClick={() =>{copyUrl()}}
                                                            ></img>
                                                        </>
                                                        ): 
                                                        <>
                                                            <img
                                                                alt="Copy"
                                                                src={Copy}
                                                                className={classes.copy}
                                                                onClick={() =>{copyUrl()}}
                                                            ></img>
                                                        </>
                                                    }
                                                </div>
                                            </section>
                                        </div>
                                    </Modal>
                    </div>
                )}

                {informacion !== null && (
                    <>
                        <div className="information">
                        <span
                            className={
                            tipoContenido === "Concepto" || tipoContenido === "Conceptos jurídicos"
                            ? "flag_card_concepto"
                            : tipoContenido === "Temas y problemas"
                            ? "flag_card_prob"
                            : tipoContenido === "Sentencia procedimiento mercantil"
                            ? "flag_card_sentencia_escrita"
                            : tipoContenido === "Sentencia en audiencia oral"
                            ? "flag_card_sentencia_video"
                            : "flag_card"
                            }
                        >
                            {tipoContenido === "Concepto" || tipoContenido === "Conceptos jurídicos" ? (
                                <img className="icon_type_content" src={icon_conceptos} alt="" />
                            ) : tipoContenido === "Temas y problemas" ? (
                                <img className="icon_type_content" src={icon_temas} alt="" />
                            ) : tipoContenido === "Sentencia procedimiento mercantil" ? (
                                <img className="icon_type_content" src={icon_sentencia} alt="" />
                            ) : (
                                <img className="icon_type_content" src={icon_sentencia_oral} alt="" />
                            )}
                            {tipoTraducido}
                        </span>
                        </div>
                        <div className="informacion-general_content">
                            {writeInformacionGeneral(informacion)}
                        </div>
                    </>
                )}
            </div>

            <div
                id="json-viewer--menu-mobile"
                className="json-viewer--menu-mobile"
            >
                <img
                    className="menu-icon"
                    src={icon_menu}
                    alt="Menu"
                    onClick={() => {
                        showMenuMobile();
                    }}
                />
                <Modal
                    open={openMenu}
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                >
                    <div className="window-menu">
                        <div className="window_title">
                            {menuIzq.length > 0 && (
                                <MenuIzquierdo
                                    activeItem={activeSection}
                                    items={menuIzq}
                                />
                            )}
                        </div>
                    </div>
                </Modal>
            </div>

            <div className="json-viewer">
                {showMenu && menuIzq.length > 0 && (
                    <div id="json-viewer--menu" className="json-viewer--menu">
                        <MenuIzquierdo
                            activeItem={activeSection}
                            items={menuIzq}
                        />
                    </div>
                )}

                <div
                    className="json-viewer--menu-control"
                    onClick={() => showMenuDesktop()}
                    title="Mostrar/Ocultar menu"
                >
                    <img
                        className={`arrow-menu ${showMenu ? "open" : "close"}`}
                        src={arrow}
                        alt="Mostrar/Ocultar"
                    />
                </div>
                <div id="json-viewer--content" className="json-viewer--content">
                    <div id={`json-detail`} className={`json-detail`}>
                        {menuIzq.length > 0 && (
                            <WriteDetail item={menuIzq[activeSection]} />
                        )}
                    </div>
                </div>
            </div>
        </>
    );
}
